export default "__VITE_ASSET__949cfc3b__"